'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const header = "_header_heod5_1";
const toprow = "_toprow_heod5_10";
const styles = {
	header: header,
	toprow: toprow
};

const PageHeaderBase = ({ topRowContent, children, className }) => {
  return React__default.default.createElement(
    "div",
    { className: clsx.clsx(styles.header, className), "data-zds": true },
    topRowContent ? React__default.default.createElement("div", { className: styles.toprow, "data-zds": true }, topRowContent) : React__default.default.createElement(designSystem.Spacer, { height: "var(--zds-space-20)" }),
    children
  );
};

exports.PageHeaderBase = PageHeaderBase;
//# sourceMappingURL=PageHeaderBase.cjs.js.map
